// Shared design tokens for the Login redesign, reused across the
// auth flow (Login, SendOTP, NewPassword) so colors/gradients are
// defined once instead of being re-typed per screen.

export const BRAND_GRADIENT =
  "radial-gradient(120% 90% at 85% 8%, rgba(111,224,168,.18), transparent 55%), radial-gradient(90% 70% at 10% 100%, rgba(8,40,28,.55), transparent 60%), linear-gradient(155deg, #176B49 0%, #11503A 42%, #0B3B2A 100%)";

export const BRAND_GLOW =
  "radial-gradient(60% 50% at 75% 0%, rgba(255,255,255,0.07), transparent 70%)";

export const BUTTON_GRADIENT = "linear-gradient(180deg,#1F8459,#176B49)";

export const tokens = {
  mint: "#6FE0A8",
  mintTint: "rgba(111,224,168,.18)",
  mintDark: "#0B3B2A",
  primary: "#1F8459",
  primaryDark: "#176B49",
  inputBorder: "#D7DED9",
  inputBorderHover: "rgba(31,132,89,0.5)",
  focusRing: "0 0 0 4px rgba(31,132,89,.12)",
  secondaryHoverFill: "#F5FBF8",
};

export const headingSx = {
  fontWeight: 700,
  fontSize: { xs: 26, sm: 28 },
  lineHeight: 1.1,
  letterSpacing: "-0.02em",
  color: "#15171a",
};

export const fieldLabelSx = {
  fontSize: 15,
  fontWeight: 600,
  color: "#15171a",
  mb: 1,
};

export const inputRootSx = {
  height: 56,
  borderRadius: "14px",
  backgroundColor: "#fff",
  transition: "all 0.2s ease",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: tokens.inputBorder,
    borderWidth: "1.5px",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: tokens.inputBorderHover,
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: tokens.primary,
    borderWidth: "1.5px",
  },
  "&.Mui-focused": {
    boxShadow: tokens.focusRing,
  },
};

export const primaryButtonSx = {
  width: "100%",
  height: 54,
  borderRadius: "14px",
  background: BUTTON_GRADIENT,
  border: `1px solid ${tokens.primaryDark}`,
  boxShadow: "0 4px 12px rgba(23,107,73,0.22)",
  transition: "transform 0.15s ease, box-shadow 0.15s ease",
  "&:hover": {
    background: BUTTON_GRADIENT,
    borderColor: tokens.primaryDark,
    transform: "translateY(-1px)",
    boxShadow: "0 6px 16px rgba(23,107,73,0.3)",
  },
  "@media (prefers-reduced-motion: reduce)": {
    transition: "none",
    "&:hover": { transform: "none" },
  },
  color: "#fff",
  textTransform: "none",
  fontSize: 16,
  fontWeight: 600,
};

export const secondaryButtonSx = {
  borderRadius: "14px",
  borderWidth: "1.5px",
  borderColor: tokens.primary,
  color: tokens.primary,
  textTransform: "none",
  fontWeight: 600,
  "&:hover": {
    borderWidth: "1.5px",
    borderColor: tokens.primary,
    background: tokens.secondaryHoverFill,
  },
};

export const stepPillSx = {
  px: 2.25,
  py: 0.7,
  borderRadius: 999,
  border: "1px solid rgba(21,23,26,0.24)",
  color: "rgba(21,23,26,0.62)",
  fontSize: { xs: 15, md: 16, lg: 18 },
  lineHeight: 1,
  textAlign: "center",
};
